

import React, {Component}from 'react';
import { scaleBand, scaleLinear } from 'd3-scale';

import Axes from './Axes';
import VBars from "./VBars";
import Tooltip from "./Tooltip";
import ChartComponent from "./../ChartComponent";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";



class Chart extends Component {
    constructor(props) {
        super(props);
        this.yScale = scaleBand();
        this.xScale = scaleLinear();

        this.state = {
            initData:[],
            datatorender:[],
            clicked: false,
            processed: true,
            hoveredData: false,
            hovering: false,
            selectedData: false,
            filterAction:false,
            selectedValues: []
        }
    }

    componentDidMount() {

        this.setState({
            initData: this.props.initData
        })

    }


    // to move
    filterData(datum){

        let {selectedValues} = this.state;

        const index = selectedValues.indexOf(datum.d);
        if (index > -1) {
            selectedValues.splice(index, 1);
        }
        else{
            selectedValues.push(datum.d)
        }

        console.log("filtering");

        // turn into array;
        this.props.handleFilter(datum.key,selectedValues);
        this.setState({selectedData:datum, clicked:true, selectedValues: selectedValues})
    }

    render() {

        if (this.state.processed && this.state.initData.length!== 0) {

            let data= this.state.initData;  //the filtered ones. At start, initData= filteredData

            let marginLeft = (window.innerWidth<1300) ? 100 : 200;

            const margins = {top: 10, right: 30, bottom: 20, left: marginLeft};
            const svgDimensions = {
                width: Math.max(this.props.parentWidth, marginLeft),
                height: 250
            };

            const maxValue = Math.max(...data.map(d => d.value));

            // scaleLinear type
            // plot dimensions

            //let plotWidth =


            const yScale = this.yScale
                .padding(0.1)
                .domain(data.map(d => d.d))
                .range([svgDimensions.height - margins.bottom, margins.top]);

            // scaleLinear type
            const xScale = this.xScale
                .domain([0, maxValue+20])
                .range([margins.left, svgDimensions.width - margins.right]);

            let showTicks = {showX: true, showY:true};
            if(data.length>3){ showTicks.showY= false}

            return (
                <div className="Chart">
                    <svg width={svgDimensions.width} height={svgDimensions.height}>
                        <Axes
                            scales={{xScale, yScale}}
                            margins={margins}
                            show_ticks = {showTicks}
                            svgDimensions={svgDimensions}
                        />
                        <VBars
                            scales={{xScale, yScale}}
                            margins={margins}
                            data={this.props.data}
                            initData = {this.state.initData}
                            color={"default"}
                            maxValue={maxValue}
                            svgDimensions={svgDimensions}
                            hoveredData = {this.state.hoveredData}
                            hovering = {this.state.hovering}
                            clicked = {this.state.clicked}
                            selectedData = {this.props.selected}
                            selectedValues={this.state.selectedValues}
                            onMouseOverCallback={datum => {
                                this.setState({hoveredData: datum, hovering:true})}}
                            onMouseOutCallback={datum => this.setState({hoveredData: false, hovering:false})}
                            onMouseClickCallback={datum => { this.filterData(datum);}}
                        />

                    </svg>

                  {/*  { this.state.hoveredData ?
                        <Tooltip
                            hoveredBar={this.state.hoveredData}
                            scales={{ xScale, yScale }}
                        /> : null
                    }*/}
                    {this.state.hoveredData
                        ? <Tooltip className="myToolTip" hoveredBar={this.state.hoveredData} scales={{xScale, yScale}}/>
                        : <Typography variant={"subtitle2"}>Hover to see value</Typography>}
                    <Divider/>
                </div>
            )
        }
        else
        {
            return (<div className={"Chart"}>No data to display</div>)
        }
    }
}


export default ChartComponent(Chart)